import apiTool from './index';

const GET_SURVEYS_URL = 'survey/get-surveys/';
const GET_PROVIDER_SURVEYS_URL = 'survey/get-provider-surveys/';
const GET_SURVEY_URL = 'survey/get-survey/';
const ADD_SURVEY_URL = 'survey/add-survey/';
const SAVE_SURVEY_OPTIONS = 'survey/save-options/';
const ADD_TARGETS_SURVEY = 'survey/add-targets/';
const ADD_RAW_RESULTS = 'survey/add-raw-results/';
const ASSIGN_PARTNER_TO_SURVEYS = 'survey/assign-provider/';
const PROVIDER_CUSTOMER_TEMPLATE = 'survey/generate-provider-template/';
const RRH_CUSTOM_TEMPLATE = 'survey/generate-rrh-template/';
const GET_REPORTING_URL = 'survey/get-reporting/';

export default {
  getReporting(payload) {
    return apiTool.post(GET_REPORTING_URL, payload);
  },
  getProviderSurveys(payload) {
    return apiTool.post(GET_PROVIDER_SURVEYS_URL, payload);
  },
  addRawResults(payload) {
    return apiTool.post(ADD_RAW_RESULTS, payload);
  },
  getSurveys(payload) {
    console.log(payload);
    return apiTool.post(GET_SURVEYS_URL, payload);
  },
  getSurvey(id) {
    return apiTool.get(GET_SURVEY_URL + id + '/');
  },
  addSurvey(payload) {
    return apiTool.post(ADD_SURVEY_URL, payload);
  },
  saveSurveyOption(payload) {
    return apiTool.post(SAVE_SURVEY_OPTIONS, payload);
  },
  addSurveyTargets(payload) {
    return apiTool.post(ADD_TARGETS_SURVEY, payload);
  },
  assignPartnerToSurveys(payload) {
    return apiTool.post(ASSIGN_PARTNER_TO_SURVEYS, payload);
  },
  providerCustomTemplate(payload) {
    return apiTool.post(PROVIDER_CUSTOMER_TEMPLATE + payload + '/');
  },
  rrhCustomTemplate(payload) {
    return apiTool.post(RRH_CUSTOM_TEMPLATE + payload + '/');
  }
};
